import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { invoiceQueryKeys } from "../api/queryKeys";

import { instance } from "@/lib/axios/instance";
import { ChannelType } from "@/types/response/ChannelType";
import { PagedResponse } from "@/types/response/PagedResponse";

type UseChannelsParams = {
  tenantId?: string | null;
  descending?: boolean;
  orderBy?: string;
  page?: number;
  pageSize?: number;
  search?: string;
  isInvoiced?: boolean;
};

/**
 * Fetches a paginated list of channels.
 * Used for displaying channels with filtering, sorting, and pagination.
 */
export function useChannels(params: UseChannelsParams = {}) {
  return useQuery<PagedResponse<ChannelType>, AxiosError>({
    queryKey: invoiceQueryKeys.channels.list({
      tenantId: params.tenantId,
      descending: params.descending,
      isInvoiced: params.isInvoiced,
      orderBy: params.orderBy,
      page: params.page,
      pageSize: params.pageSize,
      search: params.search,
    }),
    queryFn: () =>
      instance
        .get<PagedResponse<ChannelType>>(`/api/v2/Channels`, {
          params: {
            descending: params.descending,
            isInvoiced: params.isInvoiced,
            orderBy: params.orderBy,
            page: params.page,
            pageSize: params.pageSize,
            search: params.search,
            tenantId: params.tenantId || undefined,
          },
        })
        .then((res) => res.data),
    placeholderData: keepPreviousData,
    refetchOnReconnect: false,
    staleTime: 20 * 60 * 1000,
  });
}
